export default __webpack_public_path__ + "static/media/icon-third-apto.00720435.svg";